import { Component, output } from '@angular/core';
import { ProgressComponent } from 'app/shared/ui/progress/progress.component';
import { LoadingBarModule } from '../../loading-bar';
import { IconsType } from '../enums/icons.type';
import { NotificationComponent } from './notification.component';

@Component({
    selector: 'bootstrap-toast-notification',
    imports: [
        LoadingBarModule,
        ProgressComponent,
    ],
    styles: [
        `
        .toast {
            max-width: 350px;
            overflow: hidden;
            font-size: 0.875rem;
            color: var(--normal);
            background-clip: padding-box;
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 0.25rem;
            box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
            backdrop-filter: blur(10px);
        }
        .toast-header {
            display: flex;
            align-items: center;
            padding: 0.25rem 0.75rem;
            color: var(--normal);
            background-color: rgba(255, 255, 255, 0.85);
            background-clip: padding-box;
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        }
        .toast-body {
            padding: 0.75rem;
        }
        `,
    ],
    template: `
        <div class="toast mb-1 bg-white" role="alert" aria-live="assertive" aria-atomic="true">

            <div class="toast-header">
                <!-- Icon selection -->
                @if (item.icon !== IconsType.none) {
                    <div class="icon mr-2">
                        @switch (item.icon) {
                            @case (IconsType.alert) {
                                <i class="fa fa-clock-o fa-2x" aria-hidden="true"></i>
                            }
                            @case (IconsType.error) {
                                <img src="/assets/images/cross-circle.svg" alt="">
                            }
                            @case (IconsType.info) {
                                <img src="/assets/images/info-circle.svg" alt="">
                            }
                            @case (IconsType.warn) {
                                <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                            }
                            @case (IconsType.success) {
                                <i class="fa fa-check fa-2x" aria-hidden="true"></i>
                            }
                            @case (IconsType.successCircle) {
                                <img src="/assets/images/check-circle.svg" alt="">
                            }
                        }
                    </div>
                }

                <span class="font-weight-bold" [innerHTML]="title"></span>
                @if (clickIconToClose) {
                    <img src="/assets/images/ui/close.svg" class="ml-auto cursor-pointer" alt="" (click)="onClickIcon($event)">
                }
            </div>

            <div class="toast-body">
                <div [innerHTML]="content"></div>
                @if (item.showContentProgressBar) {
                    <div class="mt-1">
                        <ui-progress [seconds]="item.contentProgressBarTime ?? 60"></ui-progress>
                    </div>
                }
                @if (item.buttonActionLabel) {
                    <div class="d-flex align-items-right">
                        <button class="btn ml-auto btn-link" (click)="buttonAction()">{{ item.buttonActionLabel }}
                        </button>
                    </div>
                }
            </div>
        </div>
    `,
})
export class BootstrapNotificationComponent extends NotificationComponent {
    outputAction = output();

    closeIconAction = output();

    buttonAction() {
        this.outputAction.emit();
        if (this.item.removeAfterOutputAction) {
            super.remove();
        }
    }

    onClickIcon(event: MouseEvent) {
        if (this.closeIconAction && this.clickIconToClose) {
            this.closeIconAction.emit();
            super.onClickIcon(event);
        }
    }

    protected readonly IconsType = IconsType;
}
